import React from "react";

import ConsultarRegistro from "../../components/RegistrarFormatos/RegistrarFormato"; //Se importa el componente para los catálogos

export default function ConsultarRegistroPrincipal(props) {

    return (
        <ConsultarRegistro
        idFormato= {props.location.state.idFormato}
        casillaEspecial= {props.location.state.casillaEspecial}
        distrito= {props.location.state.distrito}
        idGeografico= {props.location.state.idGeografico}
        observaciones= {props.location.state.observaciones}
        participacion= {props.location.state.participacion}
        seccion= {props.location.state.seccion}
        secretario= {props.location.state.secretario}
        escrutador= {props.location.state.escrutador}
        accion= {props.location.state.accion}
        respuesta={-1}
        completo={1}
        />
    );
}